import { render } from "./FlagForm.vue?vue&type=template&id=60bcf23c&ts=true"
import script from "./FlagForm.vue?vue&type=script&lang=ts"
export * from "./FlagForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__